import { CodebookIdStringModel, CodebookModel, FileWrapper } from 'app/shared/model/shared.model';

export interface CreateCaseOrContinueModel {
  requestType: CodebookModel[];
  continueEntry: boolean;
  caseGroup: CodebookModel[];
  caseCategory: CodebookModel[];
  administrativeUnit: CodebookModel[];
  requestWebId: CodebookIdStringModel[];
  webId: string;
  caseAsAssignee: boolean;
  subjectType: CodebookModel[];
  applicantOibOrMb: string;
}

export const initialCaseOrContinueValues = {
  requestType: null,
  continueEntry: false,
  caseGroup: [],
  caseCategory: [],
  administrativeUnit: [],
  requestWebId: [],
  webId: '',
  caseAsAssignee: false,
  subjectType: [],
  applicantOibOrMb: '',
};

export interface CaseModel {
  idCase: number;
  webId: string;
  classification: string;
  caseCategory: string;
  caseStatus: string;
  idCaseStatus: number;
  caseActivity: string;
  caseEarhiva: boolean;
  caseActions: CaseAction[];
}

export interface CaseAction {
  key: string;
  value: string;
  confirmationText: string;
  confirmationTitle: string;
  successMessage: string;
  errorMessage: string;
  forwardAction: boolean;
}

export interface CaseCaseRegistryModel {
  caseCategory: CodebookModel[];
  caseGroup: string;
  caseCollection: string;
  webId: string;
  classification: string;
  classificationDate: Date;
  caseTypeClassification: string;
  classificationGroup: string;
  file: string;
  relation: string;
  copiedCaseWebId: string;
  description: string;
}

export interface CaseCaseRegistryModelV2 {
  caseCategory: CodebookModel[];
  caseGroup: CodebookModel[];
  caseCollection: string;
  webId: string;
  classification: string;
  classificationDate: Date;
  caseTypeClassification: string;
  classificationGroup: string;
  file: string;
  relation: string;
  copiedCaseWebId: string;
  description: string;
}

export interface CaseExecutabilityValidityModel {
  executionDate: Date;
  effectivenessDate: Date;
}

export interface CaseArchiveModel {
  retentionPeriod: CodebookModel[];
  archiveComment: string;
  archiveDate: Date;
}

export interface CaseAdministrativeFeeModel {
  generalTariff: CodebookModel[];
}

export interface CaseLegalRemedyModel {
  legalRemedy: CodebookModel[];
}

export interface CaseFinalActOtherInfoModel {
  additionalText: string;
  locationPermitAdditionalText: string;
  buildingPermitAdditionalText: string;
  usePermitAdditionalText: string;
  alterPermitAdditionalText: string;
}

export interface CaseAuthorityModel {
  authority: string;
  administrativeUnit: string;
  administrativeUnitCity: string;
}

export interface CaseModeratorsModel {
  cosolver: CosolverCaseModeratorsCodebookModel[];
  solver: SolverCaseModeratorsCodebookModel[];
}

export interface CaseAppealModel {
  readonly: boolean;
  appealDate: Date;
  appealSolutionFirstDegree: CodebookModel[];
  appealSolutionFirstDegreeDate: Date;
  appealSolutionSecondDegree: CodebookModel[];
  appealSolutionSecondDegreeDate: Date;
}

export interface CaseFinalDocumentModel {
  readonly: boolean;
  finalDocumentName: string;
  finalDocumentFileNumber: string;
  finalDocumentAdmissionDate: Date;
  resolutionType: CodebookModel[];
  resolutionDeadline: CodebookModel[];
  resolutionDeadlineExplanation: string;
  publishStartDate: Date;
  publishEndDate: Date;
}

export interface CaseListPage {
  totalElements: number;
  content: CaseModel[];
}

export interface CosolverCaseModeratorsCodebookModel {
  id: number;
  value: string;
  workPlace: string;
  workplaceClassification: string;
  title: string;
  vocation: string;
  email: string;
  phone: string;
  designation: string;
}

export interface SolverCaseModeratorsCodebookModel {
  id: number;
  value: string;
  workPlace: string;
  workplaceClassification: string;
  title: string;
  vocation: string;
  email: string
  phone: string;
  designation: string;
}

export interface Person {
  idPerson: number;
  subjectType: CodebookModel[];
  oib: string;
  firstName: string;
  lastName: string;
  companyName: string;
  country: string;
  postalCode: string;
  city: string;
  street: string;
  streetNumber: string;
  email: string;
  contactNumber: string;
}

export interface Applicant {
  idApplicant: number;
  person: Person;
}

export interface Assignee {
  idAssignee: number;
  idApplicant: number;
  idParty: number;
  person: Person;
}

export interface ApplicantView {
  idApplicant: number;
  subjectType: string;
  idSubjectType: number;
  oib: string;
  firstName: string;
  lastName: string;
  companyName: string;
}

export interface AssigneeView {
  idAssignee: number;
  idApplicant: number;
  idParty: number;
  subjectType: string;
  idSubjectType: number;
  oib: string;
  firstName: string;
  lastName: string;
  companyName: string;
}

export interface Party {
  idParty: number;
  person: Person;
}

export interface PartyView {
  idParty: number;
  subjectType: string;
  idSubjectType: number;
  oib: string;
  firstName: string;
  lastName: string;
  companyName: string;
}

export interface Building {
  idBuilding: number;
  buildingType: CodebookModel;
  additionalDescription: string;
  buildingPurpose: CodebookModel;
  buildingPurposeAdditionalDescription: string;
  requirementGroup: CodebookModel;
  ibz: string;
  energyCertificateMark: string;
  energyCertificateIssueDate: Date;
}

export interface BuildingView {
  idBuilding: number;
  idCase: number;
  idBuildingType: number;
  buildingType: string;
  additionalDescription: string;
  buildingPurpose: string;
  buildingPurposeAdditionalDescription: string;
}

export interface Construction {
  idConstruction: number;
  buildingType: CodebookModel;
  buildingPurpose: CodebookModel;
  buildingPurposeAdditionalDescription: string;
  requirementGroup: CodebookModel;
}

export interface ConstructionView {
  idConstruction: number;
  idCase: number;
  idBuildingType: number;
  buildingType: string;
  buildingPurpose: string;
  buildingPurposeAdditionalDescription: string;
}

export interface Intervention {
  idIntervention: number;
  buildingType: CodebookModel;
  buildingPurpose: CodebookModel;
  buildingPurposeAdditionalDescription: string;
  requirementGroup: CodebookModel;
}

export interface InterventionView {
  idIntervention: number;
  idCase: number;
  idBuildingType: number;
  buildingType: string;
  buildingPurpose: string;
  buildingPurposeAdditionalDescription: string;
}

export interface AttachmentPage {
  idCase: number;
  shortDescription: string;
  proofOfLegalInterest: string;
  locationPermit: string;
  attachments: Attachment[];
}

export interface Attachment {
  idCaseAttachment: number;
  name: string;
  type: CodebookModel;
  entryDate: Date;
  document?: FileWrapper;
}

export interface ParticleArrangement {
  arrangementAccess: CodebookModel[];
  arrangementDrainage: CodebookModel[];
  arrangementElectricity: CodebookModel[];
}

export interface PlannedDocumentation {
  compatibilityExplanation: string;
  upEnactmentObligation: CodebookModel[];
  projectEngineerStatement: CodebookModel[];
}

export interface CaseActFormModel {
  idCaseAct: number;
  template: CodebookModel[];
}

export interface CaseActsPage {
  totalElements: number;
  content: CaseActModel[];
}

export const caseActInitialData = {
  idCaseAct: null,
  template: [],
};

export interface CaseActModel {
  idCaseAct: number;
  name: string;
  fileNumber: string;
  createdDate: Date;
  additionalText: string;
  lastDigitalSignatureBy: string;
  active: boolean;
  classification?: string;
  applicantName?: string;
  publishStartDate?: Date;
  publishEndDate?: Date;
  locations?: string;
  canSignAct: boolean;
  canUserSeeActDocument: boolean;
  uploadedAtLeastOneAttachment: boolean;
}

export interface PubWebCaseView {
  idCase: number;
  uuid: string;
  idPerson: number;
  classification: string;
  createdDate: Date;
  caseCategory: string;
  description: string;
  caseStatus: string;
  lastCaseActName: string;
  lastCaseCreatedDate: Date;
  createAmendmentVisible: boolean;
}

export interface CasesFilter {
  webId: string;
  classification: string;
  edozvolaFilter: boolean;
  earhivaFilter: boolean;
  caseCategory: CodebookModel[];
  caseStatus: CodebookModel[];
  community: CodebookModel[];
  authority: CodebookModel[];
  administrativeUnit: CodebookModel[];
  cadastralMunicipality: CodebookModel[];
  cadastralParcel: string;
  applicantSubjectType: CodebookModel[];
  applicantOib: string;
  applicantMb: string;
  applicantFirstName: string;
  applicantLastName: string;
  applicantCompanyName: string;
}

export const initialCasesFilter = {
  webId: '',
  classification: '',
  caseCategory: [],
  caseStatus: [],
  authority: [],
  administrativeUnit: [],
  community: [],
  cadastralMunicipality: [],
  cadastralParcel: '',
  applicantSubjectType: [],
  applicantOib: '',
  applicantMb: '',
  applicantFirstName: '',
  applicantLastName: '',
  applicantCompanyName: '',
  edozvolaFilter: false,
  earhivaFilter: false,
};

